export default __webpack_public_path__ + "static/omron-5d5a1d1c13572905cad13f4013169f33.png";